'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["iconLeading", "iconTrailing", "children"];
import React from 'react';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { IconLeading } from "./IconLeading.mjs";
import { IconTrailing } from "./IconTrailing.mjs";
import { InputContainer } from "./InputContainer.mjs";
export var FormInputIcon = function FormInputIcon(_ref) {
  var iconLeading = _ref.iconLeading,
    iconTrailing = _ref.iconTrailing,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(InputContainer, Object.assign({
    $iconLeading: iconLeading,
    $iconTrailing: iconTrailing
  }, props, {
    "data-encore-id": ENCORE_DATA_IDS.FormInputIcon
  }), iconLeading && /*#__PURE__*/React.createElement(IconLeading, {
    "aria-hidden": "true",
    iconLeading: iconLeading
  }), children, iconTrailing && /*#__PURE__*/React.createElement(IconTrailing, {
    "aria-hidden": "true",
    iconTrailing: iconTrailing
  }));
};